export const CREATE_BOOKING = 'CREATE_BOOKING'
export const CREATE_BOOKING_ERR = 'CREATE_BOOKING_ERR'
export const ASSIGN_BOOKING = 'ASSIGN_BOOKING'
export const ASSIGN_BOOKING_ERR = 'ASSIGN_BOOKING_ERR'
export const CANCEL_ASSIGN_BOOKING = 'CANCEL_ASSIGN_BOOKING'
export const CANCEL_ASSIGN_BOOKING_ERR = 'CANCEL_ASSIGN_BOOKING_ERR'
export const GET_BOOKINGS = 'GET_BOOKINGS'
export const GET_BOOKINGS_ERR = 'GET_BOOKINGS_ERR'
export const GET_BOOKING = 'GET_BOOKING'
export const GET_BOOKING_ERR = 'GET_BOOKING_ERR'